import { ContentBlocks } from "eddev/blocks"
import { useAppData } from "eddev/hooks"

type Props = {}

/** @see /blocks/parts/part-footer.tsx */
export function Footer(props: Props) {
  const footerBlocks = useAppData((data) => data.footer?.contentBlocks)
  return <ContentBlocks blocks={footerBlocks} />
}
